<template>
	<div class="page-content">
		<div class="page-content__wrapper">
			<div class="page-content__content">
				<div class="table-card">
					<supply-tenders-table :table-data="getFavoritesTenders"></supply-tenders-table>
					<div class="pagination" v-if="getTendersPagination.total > getTendersPagination.limit">
						<vue-awesome-paginate
							:total-items="getTendersPagination.total"
							:items-per-page="getTendersPagination.limit"
							:max-pages-shown="3"
							v-model="curPage"
						/>
					</div>
				</div>

			</div>
		</div>
	</div>

</template>

<script>
import SupplyTendersTable from "@/components/sections/LcSupply/SupplyTenders/SupplyTendersTable.vue";
import {mapActions, mapGetters} from "vuex";

export default {
	name: "SupplyFavPage",
	components: {SupplyTendersTable},
	data() {
		return {}
	},
	async created() {
		await this.requestFavoritesTenders();
	},
	computed: {
		curPage: {
			get() {
				return Math.round(this.getTendersPagination.offset / this.getTendersPagination.limit) + 1
			},
			set(value) {
				this.updatePagination({offset: (value - 1) * this.getTendersPagination.limit})
			}
		},
		...mapGetters({
			getFavoritesTenders: 'tenders/getFavoriteTenders',
			getTendersPagination: 'tenders/getTendersPagination',

		})
	},
	methods: {
		...mapActions({
			requestFavoritesTenders: 'tenders/requestFavoritesTenders',
			updatePagination: 'tenders/updatePagination',
		})
	}
}
</script>

